
<template>
  <card>
    <h4 slot="header" class="card-title d-md-flex justify-content-between">
      <span>Yatırımcı Sözlüğü</span>
      <b-btn v-b-toggle="'addWord'" class="m-1 btn-sm">Ekle</b-btn>
    </h4>

    <b-collapse id="addWord">
      <b-card>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">Kelime</span>
          </div>
          <input type="text" class="form-control" placeholder="Başlık" aria-label="Başlık" v-model="newWord.word" id="name" aria-describedby="basic-addon1">
        </div>
        <span class="" id="basic-addon1">Açıklama</span>
        <tinymce id="d1" v-model="newWord.description" style="width: 100%" ref="tm" :other_options="options"></tinymce>
        <button class="btn btn-sm btn-success mt-3 float-right" v-on:click="saveWord()">Kaydet</button>
      </b-card>
    </b-collapse>
    <div class="d-flex align-items-center justify-content-between">
      <div class="filters my-3 d-flex justify-content-between">

        <b-button-group size="sm">
          <b-button class="btn-fill btn-success active type-button" id="type-all" v-on:click="changeType('all')">Tümü</b-button>
          <b-button v-for="item in letters" :key="item" style="" class="btn-fill btn-success type-button" id="type-1" v-on:click="changeType(item)">{{item.toUpperCase()}}</b-button>
        </b-button-group>
      </div>

      <div class="filters my-3 d-flex ml-3 w-25 align-items-center position-relatice">
        <div class="input-group w-100 ml-3">
          <input type="text" class="form-control form-control-sm border-primary text-primary" v-on:keyup="getPosts()" v-model="query" placeholder="Arama">
          <div class="input-group-append">
            <span class="input-group-text bg-white border-primary text-primary" id="basic-addon2"><i class="fas fa-circle-notch fa-spin d-none" id="small-spinner"></i></span>
          </div>
        </div>
      </div>
    </div>
    <table class="table table-hover table-striped table-bordered mb-0">
      <caption v-if="!query">Toplam: {{total}}</caption>
      <thead class="thead-dark">

        <th>Kelime</th>
        <th style="width:75%">Açıklama</th>
        <th style="width:5%">İşlem</th>
      </thead>
      <tbody>
        <tr v-for="item in table" :key="item.id">
          <td>{{item.word}}</td>
          <td v-html="item.description"></td>
          <td >
            <a href="javascript:void(0)" class="btn btn-xs btn-danger btn-fill" v-on:click="sil(item.id)" v-b-tooltip title="Sil" id="deactivate-item.id"><i class="fas fa-times fa-fw"></i></a>
          </td>
        </tr>
      </tbody>
    </table>
    <nav v-if="!query" aria-label="Page navigation small">

      <ul class="pagination justify-content-end">
        <li class="page-item" v-bind:class="{disabled: isFirst()}"><a class="page-link" v-on:click="getPosts(page - 1,type)" >Öncesi</a></li>
        <li class="page-item" v-for="current in pageCount" v-if="isInScope(current)" v-bind:class="{active: isActive(current), 'mr-2': current == 1, 'ml-2': current == pageCount.length}" :key="current"><a href="javascript:void(0)" class="page-link active" v-on:click="getPosts(current,type)">{{current}}</a></li>
        <li class="page-item" v-bind:class="{disabled: isLast()}"><a class="page-link" v-on:click="getPosts(page + 1,type)">Sonrası</a></li>
      </ul>
    </nav>


  </card>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    data: function () {
      return {
        comment:{
          is_active:0
        },
        options: {
          language_url: '/static/plugins/tinymce-lang/tr.js'
        },
        newWord:{
          letter:null,
          word:null,
          description:null
        },
        table: null,
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        query:null,
        navigation: true,
        type: 'all',
        viewCounts: [],
        letters:null
      }
    },
    components: {
      Card
    },

    methods: {
      changeType: function(t){
        this.type = t
        var buttons = Array.prototype.slice.call(document.getElementsByClassName('type-button'))
        buttons.forEach(function(b){
          b.classList.remove('active')
        })
        event.target.classList.add('active')
        this.getPosts(1,this.type)
      },
      sil: function(id){
        this.toggleLoader()
        this.comment.published = 0
        this.$http.post('/api/dictionary/delete/' + id).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Başarılı')
            this.getPosts(this.page,this.type)
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      isInScope: function(c){
        if(c === 1){
          return true
        }
        if(c === this.pageCount.length){
          return true
        }
        if(c - this.page > 3 || this.page - c > 3){
          return false;
        }
        return true
      },
      isActive: function (v) {
        return v === this.page
      },
      isFirst: function () {
        return this.page === 1
      },
      isLast: function () {
        return this.page === Math.ceil(this.total / this.limit)
      },
      getLetters: function(){
        this.$http.get('/api/dictionary/get-letters').then(response=>{
          this.letters = response.body
        },
        er => {
          this.notifier(
            'top',
            'right',
            'danger',
            'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
            )
          clearTimeout(this.tmId);
        })
      },
      saveWord:function(){
        this.newWord.letter = this.newWord.word.substring(0, 1).replace(/I/g,'ı').replace(/İ/g,'i').toLowerCase()
        this.$http.post('/api/dictionary/add', this.newWord).then(
          response => {
            this.notifier('top', 'right', 'success', 'Başarılı')
            this.newWord.word = null
            this.newWord.description = null
            this.$refs.tm.editor.setContent('')
            this.getPosts()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
          })
      },
      getPosts: function (p = 1, t = 'all') {
        if(this.query){
          if(this.tmId){
            clearTimeout(this.tmId);
          }
          this.tmId = setTimeout(()=>{
            if(this.query){
              document.getElementById('small-spinner').classList.remove('d-none');
              this.$http.get('/api/search-dictionary/' + this.query)
              .then(
                response => {
                  document.getElementById('small-spinner').classList.add('d-none');
                  this.table = response.body
                  this.table.forEach(i=>{
                    i.comment = this.$sanitize(i.comment,{allowedTags: ['user-reference']}).replace(/<user-reference>/g,'@').replace(/<\/user-reference>/g, ' ');
                  })
                  clearTimeout(this.tmId);
                },
                er => {
                  this.notifier(
                    'top',
                    'right',
                    'danger',
                    'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
                    )
                  clearTimeout(this.tmId);
                })
            }
          },700)
        }else{
          this.type = t
          var url = '/api/filter/dictionary/orderby/word:asc/limit/' + this.limit + '/page/' + p
          if(this.type !== 'all'){
           url = url + '/letter/' + this.type
         }

         this.$http.get(url).then(
          response => {
            this.table = response.body.data
            this.total = response.body.meta.total
            this.page = p
            this.pageCount = []
            for (var i = 0; i < this.total / this.limit; i++) {
              this.pageCount.push(i + 1)
            }
          },
          er => {
            this.notifier(
              'top',
              'right',
              'danger',
              'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
              )
          })
       }
     },
     toggleNavigation () {
      var button = event.target
      if (this.navigation) {
        button.innerHTML = '<i class="fas fa-caret-down"></i>'
        this.navigation = false
      } else {
        button.innerHTML = '<i class="fas fa-caret-up"></i>'
        this.navigation = true
      }
    },
    toggleNewPostPanel (event) {
      event.stopPropagation()
      if (document.getElementById('new-post').classList.contains('d-none')) {
        document.getElementById('new-post').classList.remove('d-none')
      } else {
        document.getElementById('new-post').classList.add('d-none')
      }
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.getPosts()
      this.getLetters()
    })
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/DictionaryModules/Index.vue